import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import mobile from '../../components/isMobile.vue';
export default {
  name: 'new3DList',
  data() {
    return {
      stageUrl: '',
      listPage: 1,
      list: [],
      config: {},
      columns: [],
      keyword: '',
      columnIndex: 0,
      pageNum: 0,
      isLoading: false,
      pageType: 'white',
      //white白金 black黑金
      isMobile: false,
      types: ['3D', '360', '视频', '图片'],
      a_type: 0,
      loading: true,
      paramsData: {}
    };
  },
  components: {
    mobile
  },
  methods: {
    changeList() {
      this.$router.push({
        name: 'springwaterList',
        query: this.$route.query
      });
    },
    toDetail(data) {
      let params = {
        column: this.columns[this.columnIndex].columnName,
        type: this.types[this.a_type - 1],
        keyword: this.keyword,
        page: this.listPage,
        index: this.list.findIndex(i => {
          return i.code == data.code;
        })
      };
      let url = this.$route.query.type == 'luoshen' ? 'springwaterDetail' : 'new3DDetail';
      let query = {
        fid: this.$route.query.fid,
        code: data.code,
        type: this.$route.query.type
      };
      if (params.page) {
        window.sessionStorage.setItem("searchKey", JSON.stringify(params));
      }
      data.autoCode ? query.autoCode = data.autoCode : data.m_index ? query.index = data.m_index : '';
      this.$router.push({
        name: url,
        query,
        params: params
      });
    },
    // 改变栏目
    changeColumn(index) {
      this.columnIndex = index;
      this.listPage = 1;
      this.getList();
    },
    // 滚动事件
    scrollEvent(e) {
      if (e.srcElement.scrollTop + e.srcElement.clientHeight >= e.srcElement.scrollHeight - 100) {
        if (this.isLoading) return;
        if (this.pageNum == this.listPage) return;
        this.listPage = this.listPage + 1;
        this.getList();
      }
    },
    // 获取页面配置
    getConfig(type) {
      let singleform = {
        limit: 100,
        page: 1
      };
      singleform.fid = this.$route.query.fid || '151066';
      singleform.formId = '112706';
      this.$api.singleformList(singleform).then(res => {
        let data = res.data[0];
        this.config = {
          title: this.getConfigInFormData(data.formData, 'title'),
          logo: this.getConfigInFormData(data.formData, 'logo', 'img')
        };
        document.title = this.config.title || '文物综合展示系统';
      });
    },
    // 文物列表
    getList(type, index) {
      if (type == 'types') this.a_type = index;
      if (type != 'types') this.a_type = 0;
      if (type) this.listPage = 1;
      this.isLoading = true;
      if (this.listPage == 1) this.list = [];
      let query = {
        deptId: this.$route.query.fid || '151066',
        formId: 113010,
        page: this.listPage,
        limit: 20,
        searchStr: ''
      };
      if (this.columnIndex > 0 || type) {
        let a = {
          filters: [],
          model: 0
        };
        if (this.columnIndex > 0) {
          a.filters.push([{
            alias: this.$route.query.fid == 200375 ? 'columns' : "column",
            compt: "selectbox",
            express: "match",
            range: null,
            val: [this.columns[this.columnIndex].columnName]
          }]);
        }
        if (this.keyword) {
          a.filters.push([{
            alias: "antiqueName",
            compt: "selectbox",
            express: "like",
            id: 1,
            range: null,
            val: [this.keyword]
          }]);
        }
        if (type == 'types') {
          a.filters.push([{
            alias: "type",
            compt: "selectbox",
            express: "like",
            id: 29,
            range: null,
            val: [this.types[index - 1]]
          }]);
        }
        query.searchStr = encodeURI(JSON.stringify(a));
      }
      this.$api.singleadvanceSearch(query).then(res => {
        this.pageNum = res.totalPage;
        let list = res.dataList.map((item, index) => {
          let nItem = {
            columnName: this.$route.query.fid == 200375 ? this.getValInFormData(item.formIdValueData, 'columns') : this.getValInFormData(item.formIdValueData, 'column'),
            name: this.getValInFormData(item.formIdValueData, 'antiqueName'),
            img: this.getValInFormData(item.formIdValueData, 'thumbnail', 'img'),
            code: this.getValInFormData(item.formIdValueData, 'autoId'),
            type: this.getValInFormData(item.formIdValueData, 'type'),
            index: index,
            autoCode: this.getValInFormData(item.formIdValueData, 'autoCode'),
            m_index: 0,
            showType: this.getValInFormData(item.formIdValueData, 'showType')
          };
          return nItem;
        });
        // 手动塞重复数据的index，兼容旧数据
        list.map(item => {
          if (list.filter(l => {
            return l.code == item.code;
          }).length > 1) {
            let f_list = list.filter(l => {
              return l.code == item.code;
            });
            f_list.map((f, i) => {
              list[f.index].m_index = i;
            });
          }
        });
        this.list = this.list.concat(list.filter(item => {
          return item.showType.indexOf('电脑端与移动端') > -1;
        }));
        this.isLoading = false;
      });
    },
    //获取栏目列表
    getColumn() {
      let query = {
        fid: this.$route.query.fid || '151066',
        formId: 112712,
        page: 1,
        limit: 50
      };
      this.$api.singleformList(query).then(res => {
        this.columns = res.data.map(item => {
          let nItem = {
            columnName: this.getConfigInFormData(item.formData, 'name')
          };
          return nItem;
        });
        this.columns.unshift({
          columnName: '全部'
        });
        if (this.paramsData.page) {
          this.keyword = this.paramsData.keyword;
          this.columnIndex = this.columns.findIndex(item => {
            return item.columnName == this.paramsData.column;
          }) > -1 ? this.columns.findIndex(item => {
            return item.columnName == this.paramsData.column;
          }) : 0;
          this.a_type = this.types.findIndex(item => {
            return item == this.paramsData.type;
          }) + 1;
        }
        this.a_type > 0 || this.keyword ? this.getList('types', this.a_type) : this.getList();
      });
    },
    getValInFormData(data, id, type, index) {
      index = index ? index : 0;
      if (!data[id] || !data[id].groupValues[index] || !data[id].groupValues[index].values[0].length) {
        return '';
      }
      let target;
      if (type && type == 'img') {
        if (!data[id].groupValues[index].values[0][0]) return '';
        target = process.env.NODE_ENV == 'development' ? data[id].groupValues[index].values[0][0] : data[id].groupValues[index].values[0][0].fileUrl;
        target = target && process.env.NODE_ENV != 'development' ? target.replace('http:', 'https:') : `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}`;
      } else {
        target = type ? data[id].groupValues[index].values[0][0][type] : data[id].groupValues[index].values[0][0].val;
      }
      return target;
    },
    getConfigInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values[0];
      target.file = process.env.NODE_ENV == 'development' ? `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}` : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    }
  },
  created() {
    this.pageType = this.$route.query.type || 'white';
    this.stageUrl = process.env.VUE_APP_IMG_URL;
    this.getConfig();
    this.paramsData = window.sessionStorage.getItem("searchKey") ? JSON.parse(window.sessionStorage.getItem("searchKey")) : {};
  },
  mounted() {
    this.getColumn();
  },
  beforeRouteEnter(to, from, next) {
    console.log(to, from);
    next(vm => {
      if (from.name == "new3DDetail") {
        location.reload();
      }
    });
  }
};